class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.value = this.unwrapQuery(this.input.value);
      this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  unwrapQuery(value) {
    let term = (value || '').trim();
    term = term.replace(/^(&quot;|&#34;|&#x22;|")/i, '').replace(/(&quot;|&#34;|&#x22;|")$/i, '').trim();
    if (term.length >= 2 && term.startsWith('"') && term.endsWith('"')) {
      return term.slice(1, -1).trim();
    }
    return term;
  }

  wrapQueryForSubmit() {
    const term = this.unwrapQuery(this.input.value);
    if (!term) return;
    this.input.value = `"${term}"`;
  }

  onFormSubmit(event) {
    if (event.defaultPrevented) return;
    this.wrapQueryForSubmit();
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
